// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXbeth } from "../../../icons/mono/build/icon-xbeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XbethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXbeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XbethIcon.displayName = 'XbethIcon';
}

export default XbethIcon;